<template>
    <div class="list-group-item item order-item" >
        <div class="d-flex flex-row">
        <span class="order_item--index"><b>{{ index + 1 }}</b></span>
        <span class="order-item-cus-name text-truncate mr-3" :id="`order-item-${order.id}`" :title="get(order, 'customer.name', '-')">{{ get(order, 'customer.name', '-') }}</span>
        <div class="ml-auto">
            <b-dropdown size="lg" class="order-item-dropdown-btn"  variant="link" toggle-class="text-decoration-none" no-caret>
            <template #button-content>
                <span title="Action" class="fa fa-ellipsis-v"></span>
            </template>
            <b-dropdown-item @click="onClickOrderInfo()">
                <i class="text-info fa fa-info-circle"></i> Detail
            </b-dropdown-item>
            <b-dropdown-item @click="onClickIconMove()" href="#">
                <i class="text-primary fa fa-exchange"></i> Move
            </b-dropdown-item>
            <b-dropdown-item v-if="hasShipment" @click="onClickIconUnassign()" href="#">
                <i class="text-warning fa fa-map-signs"></i> Unassign
            </b-dropdown-item>
            <b-dropdown-item href="#">
                <router-link :to="`/shipment_md/orders/${order.id}/edit`">
                <i class="text-primary fa fa-pencil-square-o"></i> Edit
                </router-link>
            </b-dropdown-item>
            <b-dropdown-item @click="onClickDeleteOrder()" href="#">
                <i class="text-danger fa fa-trash-o"></i> Delete
            </b-dropdown-item>
            <b-dropdown-item v-if="isNoLocation" @click="onClickCreateLocation()" href="#">
                <i class="text-info fa fa-location-arrow"></i> Create Location
            </b-dropdown-item>
            </b-dropdown>
        </div>
        </div>
        <div class="d-flex">
        <order-item-temp-badge :storage_types="get(order, 'metadata.storage_type')" />
        <span :title="`Weight: ${weight} kg`" class="order-item-info mx-1"><i class="fa fa-balance-scale"></i> {{ weight }}</span>
        <span :title="`Volume: ${volume} cm3`" class="order-item-info mx-1"><i class="fa fa-cube"></i> {{ volume }}</span>
        <span :title="`Quantity: ${quantity}`" class="order-item-info mx-1"><i class="fa fa-cubes"></i> {{ quantity }}</span>
        <span title="CDD" v-if="checkIsCDD(order, 'destination.metadata.CDD')" class="mx-1">
          <i class="fa fa-truck"></i>
        </span>
        <span title="Unassigned" class="mx-1" v-if="get(order, 'metadata.assign_status') === 'unassigned'">
          <i class="fa fa-calendar-times-o text-warning"></i>
        </span>
        <span title="Out of Area" class="mx-1" v-if="isOnCall">
          <i class="fa fa-plane text-primary"></i>
        </span>
        <span title="Invalid location" class="mx-1" v-if="get(order, 'destination') === null">
          <i class="fa fa-map-signs text-danger"></i>
        </span>
        </div>
        <b-popover :target="`order-item-${order.id}`" triggers="hover blur" placement="left">
        <template #title>{{ order.number }}</template>
        <b-row>
            <dt class="col-sm-4">Customer</dt>
            <dd class="col-sm-8">{{ get(order, 'customer.name') }}</dd>
            <dt class="col-sm-4">City</dt>
            <dd class="col-sm-8">{{ get(order, 'metadata.customer_city') }}</dd>
            <dt class="col-sm-4">Address</dt>
            <dd class="col-sm-8">{{ get(order, 'metadata.customer_address') }}</dd>
            <dt class="col-sm-4">Segment</dt>
            <dd class="col-sm-8">{{ get(order, 'metadata.segment') }}</dd>
        </b-row>
        <hr class="margin:0;">
        <b-row class="mt-1">
            <dt class="col-sm-4">Type</dt>
            <dd class="col-sm-8">{{ get(order, 'metadata.storage_type') }}</dd>
            <dt class="col-sm-4">Weight</dt>
            <dd class="col-sm-8">{{ weight }} kg</dd>
            <dt class="col-sm-4">Volume</dt>
            <dd class="col-sm-8">{{ volume }} cm<sup>3</sup></dd>
            <dt class="col-sm-4">Quantity</dt>
            <dd class="col-sm-8">{{ quantity }}</dd>
        </b-row>
        </b-popover>
    </div>
</template>
<script>

import { round, get, isEmpty } from 'lodash';
import OrderItemTempBadge from './OrderItemTempBadge.vue';

export default {
  components: { OrderItemTempBadge },
  name: 'OrderItem',
  props: {
    order: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
    hasShipment: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    weight() {
      return round(get(this.order, 'metadata.total_gross_weight'), 2);
    },
    volume() {
      return round(get(this.order, 'metadata.total_gross_volume'), 2);
    },
    quantity() {
      return round(get(this.order, 'metadata.total_quantity_unit'), 2);
    },
    isOnCall() {
      return get(this.order, 'metadata.shipmentType') === 'on_call';
    },
    isNoLocation() {
      return isEmpty(this.order.destination);
    },
  },
  methods: {
    get(...args) {
      return get(...args);
    },
    roundNum(num, t) {
      return round(num, t);
    },
    onClickOrderInfo() {
      this.$emit('clickOrderInfo');
    },
    onClickIconMove() {
      this.$emit('clickIconMove');
    },
    onClickDeleteOrder() {
      this.$emit('clickDeleteOrder');
    },
    onClickCreateLocation() {
      this.$emit('clickCreateLocation');
    },
    onClickIconUnassign() {
      this.$emit('clickIconUnassign');
    },
    checkIsCDD(obj, key) {
      const cdd = this.get(obj, key);
      const isCdd = Number(cdd) === 1;
      return isCdd && this.orderType() === 'D';
    },
    orderType() {
      const sType = get(this.order, 'metadata.storage_type');
      if (sType.match(/fro?ze?(n|d)?/i)) {
        return 'F';
      } else if (sType.match(/chi?ll?(e(r|d))?/i)) {
        return 'C';
      } else if (sType.match(/(ac|dry)/i)) {
        return 'D';
      }
      return '';
    },
  },
};
</script>
<style lang="sass">
.order-item-dropdown-btn > .dropdown-toggle
  padding: 0 0.7rem !important
  color: #151b1e
.list-group-item.order-item
  padding: 0.75rem 0.55rem 0.75rem 1.25rem
</style>
<style lang="sass" scoped>
.order_item--index
  margin-right: 10px;

.order_item--action
  position: absolute;
  top: 5px;
  right: 7px;

.order_item--action .fa-ellipsis-v
  color: black !important;

.order-item-info
  font-size: 0.8rem

.order-item-cus-name
  cursor: default
</style>



// WEBPACK FOOTER //
// src/components/shipment_md/OrderItem.vue